import packageInfo from '../../../../package.json';

export const environment = {
  version: `v${packageInfo.version}`,
  /** Shows the banner that says nothing here reaches the real business. */
  testEnvironment: true,
  production: false,
  apiUrl: 'https://api.staging.iqd-pro.com',
  /** The Ask Derek assistant, which is its own service rather than part of the API. */
  insightApiUrl: 'https://insight-api.staging.iqd-pro.com',
  graphql: {
    uri: 'https://api.staging.iqd-pro.com/graphql',
    wsUri: 'wss://api.staging.iqd-pro.com/graphql',
  },
  auth0: {
    domain: 'auth.staging.iqd-pro.com',
    clientId: '35xPo44OMHrhb27cOJ3iGasTIPCaJjR5',
    audience: 'https://api.staging.iqd-pro.com',
    claimsNamespace: 'https://iqd-pro.com/claims/',
    // Auth0 recommends renewing through a first-party silent-auth iframe
    // over holding a refresh token, when the Auth0 domain is same-site
    // with the app: nothing renewable is left at rest for an XSS to read.
    // Where that does not hold — localhost — fall back to refresh tokens.
    useSilentAuth: true,
    /**
     * The Entra ID connection a staff member may link their account to, from
     * the user settings screen. Empty until that connection exists in the
     * tenant, and empty is what hides the option.
     */
    microsoftConnection: '',
  },
  sentry: {
    environment: 'staging',
    dsn: 'https://9e2076247dd9307fad7340545883ddd0@o4509351712194560.ingest.de.sentry.io/4509351713964112',
    enabled: true,
  },
  links: {
    /** The public 3D viewer, which MezzViewer opens a quote in. */
    viewer3d: 'https://3d-viewer.test.iqd-pro.com/',
    budgetCalculator: 'https://budget.test.iqd-pro.com',
  },
  boxOAuth: {
    authorizeUrl: 'https://api.staging.iqd-pro.com/auth/box/authorize',
    tokenUrl: 'https://api.staging.iqd-pro.com/auth/box/token',
  },
  // Feature flags: switch on work that is merged but not yet released, or
  // switch off a screen that is being replaced. Nothing is behind one at the
  // moment; add a boolean here and to the other two environment files.
  features: {},
};
